// extracted by mini-css-extract-plugin
export default {"wrapper":"Poper_wrapper__Dh5PU"};